(function () {
  'use strict';

    angular
      .module('tfc.retailer.Returns')
      .controller('ReturnsPerformanceParentCtrl', ReturnsPerformanceParentCtrl)
      .controller('ReturnsPerformanceBySizeCtrl', ReturnsPerformanceBySizeCtrl)
      .controller('ReturnsPerformanceCtrl', ReturnsPerformanceCtrl)
      .filter('unique',UniqueFilter);

  // @ngInject
  function ReturnsPerformanceParentCtrl(translateFilter,PageSize,$scope,$state,$stateParams,ColorCode,DashboardDescriptionModal){

    var vm = this;
    vm.sortCommonColumn = sortCommonColumn;
    vm.getColorSwatch = getColorSwatch;
    vm.getReturnsChart = getReturnsChart;
    vm.setSortConfig = setSortConfig;
    vm.updateUrl = updateUrl;

    vm.pageSize = PageSize;
    vm.maxSize = 7;

    vm.offsets = [];
    vm.isProductDetailAccessible = $state.can('productDetail');

    vm.translateText = function (text) {
      return translateFilter('reports.returns.' + text)
    };

    vm.ALL_STYLES = vm.translateText('allStyles');
    vm.ALL_CATEGORIES = vm.translateText('allCategories');
    vm.activeView = (!vm.activeView) ? vm.translateText('view.Basic') : vm.activeView;
    vm.reportKeys = ColorCode.getKeys();

    function initSortConfig(){
      var categoryName = 'categoryName';
      var variance = 'variance';
      if($stateParams.hierarchy === vm.ALL_CATEGORIES){
        vm.selectedSortField = variance;
      }else{
        vm.selectedSortField = $stateParams.sortBy === categoryName ?  variance : $stateParams.sortBy || variance;
      }
      vm.selectedSortOrder = $stateParams.sortOrder || vm.selectedSortField === variance ? 'desc' : 'asc';
    }

    function initializeState(){
      vm.currentPage = $stateParams.pageNumber;
      initSortConfig();
    }

    function setSortConfig(columnName, sortOrder){
      vm.selectedSortField = columnName;
      vm.selectedSortOrder = sortOrder;
    }

    function getColorSwatch(value){
      return ColorCode.getColor(_.isNumber(value) ? (value * 100).toFixed(1) : "");
    }

    function getReturnsChart(dataObject, other) {
      var filterDataObject = _.filter(dataObject, function(res) {
        if((res.dataNameLabel.toLowerCase().indexOf(other.filteredText.toLowerCase()) !== -1) || (res.dataTitleLabel && res.dataTitleLabel.toLowerCase().indexOf(other.filteredText.toLowerCase()) !== -1)) return res;
      });
      var chartData = filterDataObject.slice((other.currentPage - 1) * vm.pageSize, other.currentPage * vm.pageSize);

      return {
        filteredCount: filterDataObject.length || 0,
        chartData: chartData || []
      };
    }

    function updateUrl(params){
      $state.go('.', params, {notify: false});
    }

    function sortCommonColumn(unfilteredData) {
      var sortedData = _.orderBy(unfilteredData, function (style) {
        switch (vm.selectedSortField) {
          case 'styleId' :
          case 'sizeName' :
          case 'categoryName':
            return _.lowerCase(style.dataNameLabel);
          case 'styleName' :
            return _.lowerCase(style.dataTitleLabel);
          case 'variance' :
            return (style.returnVariationData !== "") ? style.returnVariationData : (vm.selectedSortOrder === 'desc') ? Number.NEGATIVE_INFINITY: Number.POSITIVE_INFINITY;
        }
      }, vm.selectedSortOrder);
      return sortedData;
    }

    vm.isUnsorted = function (columnName) {
      return vm.selectedSortField !== columnName
    };

    vm.getSortClass = function(columnName){
      var sort = 'fa fa-sort';
      if(vm.selectedSortField === columnName) {
        return sort+'-'+vm.selectedSortOrder;
      }else {
        return sort;
      }
    };

    vm.openDescriptionModal = function (selectedBrand, type, isActivityExist, isRegionExist, selectedActivity) {
      DashboardDescriptionModal.showModal(selectedBrand, type, isActivityExist, isRegionExist, selectedActivity);
    };

    initializeState();

  }
  // @ngInject
  function ReturnsPerformanceCtrl($state, $stateParams, $injector, CookieJar, summary, styleData, brands, $scope, ReturnPerformanceReport,
                                  $controller, filters, Enums, GaUtil, ChartService, aggregationLogDetails) {

    var vm = this;
    angular.extend(vm, $controller('ReturnsPerformanceParentCtrl', {$scope: $scope}));

    vm.brands = brands;
    vm.selectedBrand = _.find(vm.brands, {key: $stateParams.brandKey});
    vm.filteredStyle = "";
    vm.returnsPerformanceReportKeys = [];
    vm.offsets = [];
    angular.copy(vm.reportKeys, vm.returnsPerformanceReportKeys);
    vm.aggregationDetails = aggregationLogDetails;
    vm.hierarchies= _(summary).map(function(o){
      return {
        department: o.department,
        category: o.category,
        variationPercentage:(!_.isUndefined(o.returnVariation)) ? (o.returnVariation * 100).toFixed(1) : "",
        display: o.category ? o.department + "/" + o.category : o.department
      }
    }).value();

    vm.hierarchies.unshift({ display : vm.ALL_CATEGORIES },{ display : vm.ALL_STYLES });

    vm.unfilteredStyleData = _(styleData).map(function(data) {
      return {
        performanceCategoryLabel: (!_.isUndefined(data.returnVariation)) ? (data.returnVariation * 100).toFixed(1) : "",
        dataNameLabel : data.styleId,
        dataTitleLabel : data.styleName,
        returnVariationData : (!_.isUndefined(data.returnVariation)) ? data.returnVariation : "",
        sizeAdvice: (!_.isUndefined(data.sizeAdvice)) ? data.sizeAdvice : undefined
      }
    }).value();

    vm.unfilteredSummaryData = _(summary).map(function(data) {
      return {
        performanceCategoryLabel: (!_.isUndefined(data.returnVariation)) ? (data.returnVariation * 100).toFixed(1) : "",
        dataNameLabel : data.department+'/'+data.category,
        returnVariationData : (!_.isUndefined(data.returnVariation)) ? data.returnVariation : "",
        sizeAdvice: (!_.isUndefined(data.sizeAdvice)) ? data.sizeAdvice : undefined
      }
    }).value();

    vm.activityRegionFilters = filters;

    var selectedTransaction = vm.activityRegionFilters && vm.activityRegionFilters.getSelected();
    var selectedRegion = selectedTransaction && selectedTransaction.getSelectedRegion();

    vm.selectActivityAndReload = function(activity){
      selectedTransaction = activity;
      GaUtil.sendGaEvent(vm.selectedBrand.key, 'Activity Filter', activity.label);
      vm.reload();
    };

    vm.selectRegionAndReload = function (region) {
      selectedRegion = region;
      GaUtil.sendGaEvent(vm.selectedBrand.key, 'Region Filter', region.labelDescription);
      vm.reload();
    };

    getReturnsPerformanceKeyArr();

    vm.selectedBrandReload = function (selectedBrand) {
      vm.selectedBrand = selectedBrand;
      vm.reload(true);
    };

    vm.reload = function(resetBrand) {
      CookieJar.set({name : 'tfc-insight-selected-brand',value : encodeURIComponent(_.toString(vm.selectedBrand.key))});
      if(!resetBrand) {
        $state.go('.', { brandKey : vm.selectedBrand.key, hierarchy: vm.selectedHierarchy.display,
          department: vm.selectedHierarchy.department, category: vm.selectedHierarchy.category,
          transaction: selectedTransaction && selectedTransaction.getLabel(),
          region: selectedRegion && selectedRegion.getLabel(),
          pageNumber: vm.currentPage} );
      }else {
        $state.go('.', { brandKey : vm.selectedBrand.key},{inherit: false});
      }
    };

    vm.currentPage = $stateParams.pageNumber || 1;
    if(!$stateParams.hierarchy || $stateParams.hierarchy === vm.ALL_CATEGORIES) {
      vm.selectedHierarchy = vm.hierarchies[0];
    }else if($stateParams.hierarchy === vm.ALL_STYLES){
      vm.selectedHierarchy = vm.hierarchies[1];
    }else {
      vm.selectedHierarchy = _.find(vm.hierarchies, {department: $stateParams.department, category: $stateParams.category});
      if(!vm.selectedHierarchy){
        vm.selectedHierarchy = vm.hierarchies[0];
      }
    }

    function getReturnsPerformanceKeyArr(){
      var transaction = vm.activityRegionFilters.getSelected() && vm.activityRegionFilters.getSelected().getLabel();
      if(transaction === Enums.TransactionFilterType.Wholesale) {
        return angular.copy(vm.reportKeys, vm.returnsPerformanceReportKeys);
      } else {
        return _.remove(vm.returnsPerformanceReportKeys,{key: 'one-retailer-color-key'})
      }
    }

    vm.setSelectedHierarchy = function(hierarchy) {
      vm.selectedHierarchy = hierarchy;
      GaUtil.sendGaEvent(vm.selectedBrand.key, "Category Filter", vm.selectedHierarchy.display);
    };

    function setReturnsChart(dataObject, other){
      var unfilteredData = [];
      if(dataObject && dataObject.length){
        unfilteredData = dataObject;
      } else {
        unfilteredData = (vm.selectedHierarchy && vm.selectedHierarchy.display === vm.ALL_CATEGORIES) ? vm.unfilteredSummaryData: vm.unfilteredStyleData;
      }
      other.filteredText = vm.filteredStyle;
      vm.offsets = [];
      var returnsChartObj = vm.getReturnsChart(unfilteredData, other);
      vm.filteredCount = returnsChartObj.filteredCount;
      vm.chartVarianceData = returnsChartObj.chartData;
      if(vm.selectedHierarchy && vm.selectedHierarchy.display !== vm.ALL_CATEGORIES){
        _.map(vm.chartVarianceData,function(res) {
          var sizeAdviceChart = {sizeAdviceChart: ChartService.getSizeAdviceChart([{'sizeAdvice': res.sizeAdvice}])};
          _.assign(res, sizeAdviceChart);
        });
      }
    }

    vm.showSizeAdviceChart = function(index) {
      var divStatus = angular.element(document.querySelector('.chart-block-' + index))[0];
      var currentCaret = angular.element(document.querySelector('.caret-' + index))[0];
      var divCurrentStyle = divStatus && getComputedStyle(divStatus);
      if (divStatus && divCurrentStyle) {
        if (divCurrentStyle.display === "none") {
          divStatus.style.display = "block";
          currentCaret.classList.remove('fa-caret-down');
          currentCaret.classList.add('fa-caret-up');
        } else {
          divStatus.style.display = "none";
          currentCaret.classList.remove('fa-caret-up');
          currentCaret.classList.add('fa-caret-down');
        }
      }
    };

    vm.downloadReturnsReport = function () {
      var hierarchy = vm.selectedHierarchy;
      ReturnPerformanceReport.downloadReport(hierarchy && hierarchy.display,
          vm.selectedBrand && vm.selectedBrand.key,
          hierarchy && hierarchy.department,
          hierarchy && hierarchy.category,
          selectedRegion && selectedRegion.getLabel(),
          selectedTransaction && selectedTransaction.getLabel(),
          vm.selectedSortField,
          vm.selectedSortOrder,
          "ReturnsPerformance",
          vm.activityRegionFilters && vm.activityRegionFilters.hasMultipleActivity(),
          selectedTransaction && selectedTransaction.hasMultipleRegion()
      );
    };

    vm.setFilteredText = function () {
      vm.currentPage = 1;
      vm.sortByColumn();
    };

    vm.applyPagination = function(currentPage) {
      vm.currentPage = currentPage || $stateParams.pageNumber || 1;
      vm.sortByColumn();
    };

    vm.sortByColumn = function (columnName) {
      vm.setSortConfig(columnName || vm.selectedSortField, vm.selectedSortOrder);
      var unfilteredData = vm.selectedHierarchy.display === vm.ALL_CATEGORIES ? vm.unfilteredSummaryData : vm.unfilteredStyleData;
      unfilteredData = vm.sortCommonColumn(unfilteredData);
      vm.updateUrl({pageNumber: vm.currentPage, sortBy: vm.selectedSortField, sortOrder: vm.selectedSortOrder});
      setReturnsChart(unfilteredData, {currentPage: vm.currentPage});
    };

    vm.onColumnSelection = function(columnName){
      vm.currentPage = 1;
      vm.selectedSortField = columnName;
      vm.selectedSortOrder = vm.selectedSortOrder === 'asc' ? 'desc' : 'asc';
      vm.sortByColumn(columnName);
    };

    vm.navigatePage = function(styleId){
      if(vm.isProductDetailAccessible && styleId) {
        var params = _.merge($stateParams, {
          styleId: styleId,
          regionDescription: selectedRegion && selectedRegion.labelDescription,
          previousState: $state.current && $state.current.data && $state.current.data.title,
          sortBy: vm.selectedSortField,
          sortOrder: vm.selectedSortOrder
        });
        $state.go('productDetail', params);
      }
    };

    vm.sortByColumn();

  };

  function ReturnsPerformanceBySizeCtrl($state, $stateParams,$scope, CookieJar,summary,brands,hierarchies,$timeout,ReturnPerformanceReport,$controller,$filter, GaUtil, aggregationLogDetails) {

    var vm = this;
    angular.extend(vm, $controller('ReturnsPerformanceParentCtrl', {$scope: $scope}));

    vm.brands = brands;
    vm.gaUtil = GaUtil;
    vm.filteredSize = "";
    vm.selectedBrand = _.find(vm.brands, {key: $stateParams.brandKey});

    vm.hierarchies = _(hierarchies).map(function (o) {
      return {
        department: o.department,
        category: o.category,
        display: o.category ? o.department + " " + o.category : o.department
      }
    }).value();

    vm.sizeType = _(hierarchies).map(function (o) {
      return {
        sizeType: o.sizeType,
        key:o.sizeType,
        display: o.displaySizeType
      }
    }).value();

    var unsortedLocale = _(hierarchies).map(function (o) {
      return {
        localeCode: o.localeCode,
        key:o.localeCode,
        display: o.displayLocaleCode
      }
    }).value();

    vm.unfilteredSizeSummary = _(summary).map(function (data) {
      return {
        performanceCategoryLabel: (data.returnVariation * 100).toFixed(1),
        dataNameLabel: data.size,
        returnVariationData: data.returnVariation
      }
    }).sortBy(function(o){
      return o.returnVariationData * -1
    }).value();

    vm.localeCode = $filter('sortBy')(unsortedLocale, 'localeCode', 'asc');
    vm.aggregationDetails = aggregationLogDetails;

    vm.selectedHierarchy = _.find(vm.hierarchies, {department: $stateParams.department, category: $stateParams.category}) || vm.hierarchies[0];

    vm.selectedSizeType = _.find(vm.sizeType, {sizeType: $stateParams.sizeType}) || vm.sizeType[0];

    vm.selectedLocaleCode = _.find(vm.localeCode, {localeCode: $stateParams.localeCode}) || vm.localeCode[0];

    vm.selectedBrandReload = function (selectedBrand) {
      vm.selectedBrand = selectedBrand;
      vm.reload(true);
    };

    vm.reload = function (resetBrand) {
      CookieJar.set({name: 'tfc-insight-selected-brand', value: _.toString(vm.selectedBrand.key)});
      var hierarchy = vm.selectedHierarchy;
      var sizeType = vm.selectedSizeType;
      var localeCode = vm.selectedLocaleCode;
      if(!resetBrand){
        $state.go('.', {
          brandKey: vm.selectedBrand.key,
          department: hierarchy && hierarchy.department,
          category: hierarchy && hierarchy.category,
          sizeType: sizeType && sizeType.sizeType,
          localeCode: localeCode && localeCode.localeCode
        });
      }else {
        $state.go('.', { brandKey : vm.selectedBrand.key},{inherit: false});
      }
    };

    vm.getColorSwatch();

    function setReturnsChart(dataObject, other) {
      var unfilteredSizeSummary = [];
      if(dataObject && dataObject.length){
        unfilteredSizeSummary = dataObject;
      } else {
        unfilteredSizeSummary = vm.unfilteredSizeSummary;
      }
      other.filteredText = vm.filteredSize;
      var filteredData = vm.getReturnsChart(unfilteredSizeSummary, other);
      vm.filteredCount = filteredData.filteredCount;
      vm.chartVarianceData = filteredData.chartData;
    }

    vm.downloadReturnsReport = function () {
      var hierarchy = vm.selectedHierarchy;
      var sizeType = vm.selectedSizeType;
      var localeCode = vm.selectedLocaleCode;

      ReturnPerformanceReport.downloadSizeReport(hierarchy && hierarchy.display,
          vm.selectedBrand && vm.selectedBrand.key,
          hierarchy && hierarchy.department,
          hierarchy && hierarchy.category,
          sizeType && sizeType.sizeType,
          localeCode && localeCode.localeCode,
          vm.selectedSortField,
          vm.selectedSortOrder,
          "ReturnsPerformanceBySize");
    };

    vm.setFilteredText = function () {
      vm.currentPage = 1;
      vm.sortByColumn();
    };

    vm.sortByColumn = function (columnName) {
      vm.setSortConfig(columnName || vm.selectedSortField, vm.selectedSortOrder);
      var unfilteredSizeSummary = vm.sortCommonColumn(vm.unfilteredSizeSummary);
      vm.updateUrl({pageNumber: vm.currentPage, sortBy: vm.selectedSortField, sortOrder: vm.selectedSortOrder});
      setReturnsChart(unfilteredSizeSummary, {currentPage: vm.currentPage});
    };

    vm.applyPagination = function (currentPage) {
      vm.currentPage = currentPage || $stateParams.pageNumber || 1;
      vm.sortByColumn();
    };

    vm.onColumnSelection = function(columnName){
      vm.currentPage = 1;
      vm.selectedSortField = columnName;
      vm.selectedSortOrder = vm.selectedSortOrder === 'asc' ? 'desc' : 'asc';
      vm.sortByColumn(columnName);
    };

    vm.sortByColumn();
  }

  function UniqueFilter() {
    return function (items) {
      return _.uniqBy(items,function(o){
        return o.display;
      });
    };
  }

})();